module.exports = __webpack_public_path__ + "img/Postmodernisme_Tanker_i_tiden2.81c28a1e.jpg";